import { defineComponent as S, toRefs as y, computed as O, inject as F, ref as m, onMounted as D, onBeforeUnmount as L, watch as w, openBlock as I, createElementBlock as k, provide as h, renderSlot as M, createCommentVNode as P } from "vue";
const f = {
  STRIPE_NOT_LOADED: "Stripe is not loaded. Include it as script or load using loadStripe method of @stripe/stripe-js",
  INSTANCE_NOT_DEFINED: "Stripe instance is not defined. Initialize Stripe before creating elements",
  ELEMENTS_NOT_DEFINED: "Elements object is not defined. You can't create stripe element without it",
  ELEMENT_TYPE_NOT_DEFINED: "elementType is required. You can't create stripe element without it"
}, R = (t, e) => {
  try {
    if (!window.Stripe)
      throw new Error(f.STRIPE_NOT_LOADED);
    return window.Stripe(t, e);
  } catch (o) {
    console.error(o);
  }
}, C = (t, e) => {
  try {
    if (!t)
      throw new Error(f.INSTANCE_NOT_DEFINED);
    return e != null && e.clientSecret, t.elements(e);
  } catch (o) {
    console.error(o);
  }
}, g = (t, e, o) => {
  try {
    if (!t)
      throw new Error(f.ELEMENTS_NOT_DEFINED);
    if (!e)
      throw new Error(f.ELEMENT_TYPE_NOT_DEFINED);
    return t.create.bind(t)(e, o);
  } catch (l) {
    console.error(l);
  }
}, T = [
  "change",
  "ready",
  "focus",
  "blur",
  "click",
  "escape",
  "loaderror",
  "loaderstart"
], Y = /* @__PURE__ */ S({
  __name: "StripeElement",
  props: {
    type: {},
    elements: {},
    options: {}
  },
  emits: T,
  setup(t, { expose: e, emit: o }) {
    const l = t, d = o, { type: u, elements: s, options: n } = y(l), v = O(() => s.value ? "card" : "payment"), c = F("providedElements"), _ = m(document.createElement("div")), r = m(), N = m();
    return D(() => {
      const p = () => {
        var i, a;
        r.value = g(
          s.value || c.value,
          u.value || v.value,
          n.value
        ), (i = N.value) == null || i.appendChild(_.value), (a = r.value) == null || a.mount(_.value);
      }, E = () => {
        function i(a) {
          return !!a && typeof a.on == "function";
        }
        if (r.value && i(r.value))
          for (const a of T)
            r.value.on(a, (b) => {
              d(a, b);
            });
      };
      try {
        p(), E();
      } catch (i) {
        console.error(i);
      }
    }), L(() => {
      var p, E;
      (p = r.value) == null || p.unmount(), (E = r.value) == null || E.destroy();
    }), w(n, () => {
      n.value && r.value && "update" in r.value && r.value.update(n.value);
    }), e({
      stripeElement: r,
      domElement: _,
      mountPoint: N
    }), (p, E) => (I(), k("div", {
      ref_key: "mountPoint",
      ref: N
    }, null, 512));
  }
}), x = { key: 0 }, j = /* @__PURE__ */ S({
  __name: "StripeElements",
  props: {
    stripeKey: {},
    instanceOptions: {},
    elementsOptions: {}
  },
  setup(t, { expose: e }) {
    const o = t, { stripeKey: l, instanceOptions: d, elementsOptions: u } = y(o), s = m(), n = m(), v = O(() => n.value ? Object.keys(n.value).length > 0 : !1);
    return D(() => {
      s.value = R(l.value, d.value), n.value = C(s.value, u.value);
    }), w(u, () => {
      var c;
      (c = n.value) == null || c.update(u.value);
    }), h("providedInstance", s), h("providedElements", n), e({
      elements: n,
      instance: s,
      elementsUsable: v
    }), (c, _) => v.value ? (I(), k("div", x, [
      M(c.$slots, "default", {
        instance: s.value,
        elements: n.value
      })
    ])) : P("", !0);
  }
});
export {
  Y as StripeElement,
  j as StripeElements,
  g as createElement,
  C as createElements,
  R as initStripe
};
